// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
// import './configurePartialUpdate';
// import './configureTurbolinks';

// css
import '../css/main.less';



// WEBPACK FOOTER //
// ./fe/web-default/src/js/index.js